import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    memo: {
        name: () => '简述',
    },

    eventTitle: {
        name: () => '事件标题',
        required: () => true,
    },

    eventUserCode: {
        name: () => '事件代码',
    },
})
